const awsmobile =  {
    "aws_appsync_graphqlEndpoint": "https://cjs6amtk6febdgza3cqaeupiwa.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-4jlenuhskjeg3nok5qhtwkmxsa",
};

export default awsmobile;